import { Link } from 'react-router-dom';
import { Tag, Tooltip } from 'antd';
import { WalletOutlined } from '@ant-design/icons';
import { useCredits } from '../../hooks/use_credits';

/**
 * A small reminder on a call's waiting room of what joining will cost: the
 * caller's credit balance and the per-minute rate, linking to /account where
 * packs are sold. Renders nothing on a node without credits, for a guest, or
 * before the balance is known — the waiting room must not flash a tag.
 */
function CreditsBalanceTag() {
    const { enabled, balance, perMinute, enforce, loading, error } = useCredits();
    if (!enabled || error || (loading && balance === 0)) return null;
    const low = balance <= 0;
    const hint = enforce && low
        ? 'You need credits to join this call'
        : `Calls cost ${perMinute} ${perMinute === 1 ? 'credit' : 'credits'} per minute`;
    return (
        <Tooltip title={hint}>
            <Link to="/account" style={{ lineHeight: 0 }}>
                <Tag
                    icon={<WalletOutlined />}
                    color={low ? 'warning' : 'default'}
                    style={{ cursor: 'pointer', marginInlineEnd: 0 }}
                >
                    {balance} {balance === 1 ? 'credit' : 'credits'} · {perMinute}/min
                </Tag>
            </Link>
        </Tooltip>
    );
}

export default CreditsBalanceTag;
